import { Component } from 'react'
import { Row, Col, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import ScrollArea from 'react-scrollbar'
import FlashDetect from 'flash-detect'
import {
  FeedbackContainer,
  FavouritesToggle,
  CopyUrl,
  ContentMailerContainer,
  RelatedContentContainer
} from 'containers'
import { IMG_HANDLER_URL } from 'constants'
import createStyles from './styles'

import TutorialStep from 'components/TutorialStep'
import InteractiveDevice from 'components/InteractiveDevice'
import ImageDevice from 'components/ImageDevice'
import FlashDevice from 'components/FlashDevice'
import Html5Device from 'components/Html5Device'
import Panel from 'components/Panel'
import messages from './messages'
import STYLES from '../../constants/styles'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'

const MobileDevice = ({
  show,
  hide,
  stepData,
  playStepAnimation,
  updateStep,
  styleBase,
  createUserEvent,
  windowDimensions,
  currentStep
}) => (
  <Modal show={show}>
    <div
      onClick={() => {
        hide()
      }}
    >
      <InteractiveDevice
        stepData={stepData}
        playStepAnimation={playStepAnimation}
        updateStep={updateStep}
        styleBase={styleBase}
        createUserEvent={createUserEvent}
        windowDimensions={windowDimensions}
        currentStep={currentStep}
      />
    </div>
  </Modal>
)

const StepListStyle = styled.ul`
  list-style-type: none;

  @media only screen and (max-width: 768px) {
    padding-left: 0;
  }
`

class Tutorial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSurveyModal: false,
      showMobileDevice: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.data.id !== prevProps.data.id ||
      this.props.data.steps.currentId !== prevProps.data.steps.currentId
    ) {
      // Scroll to top on last step to fix scrollarea height after switching from landscape view
      if (this.props.data.steps.nextStepId === 0) {
        this.refs.scrollArea.scrollTop()
      } else {
        const offset = document.getElementById('step-active').offsetTop - 105
        this.refs.scrollArea.scrollYTo(offset < 0 ? 0 : offset)
      }
    }
  }
  automatedStep() {
    const tutorialSteps = this.props.currentTutorial
      .map((tutorial) => tutorial.tutorialstep)
      .slice(0, -1)
    const automatedStep = tutorialSteps.findIndex((step) => {
      return step.swipeOrAction === 'NONE'
    })

    return automatedStep
  }
  openMobileDevice() {
    this.props.createUserEvent({
      category: 'tutorials',
      data: {
        action: 'MobileStepImageOpen',
        target: this.props.data.id,
        step_to: this.props.data.steps.currentId
      }
    })
    this.setState({ showMobileDevice: true })
  }

  closeMobileDevice() {
    this.props.createUserEvent({
      category: 'tutorials',
      data: {
        action: 'MobileStepImageClose',
        target: this.props.data.id,
        step_to: this.props.data.steps.currentId + 1
      }
    })
    this.setState({ showMobileDevice: false })
  }

  faqTextCombined() {
    const stepList = this.props.data.steps.stepList
    const tutorialSteps = this.props.currentTutorial.map(
      (tutorial) => tutorial.tutorialstep
    )
    const images = tutorialSteps.map((step) => ({
      src: step.imageLocation,
      orientation: step.orientation
    }))

    return stepList
      .map((step, i) => {
        const imgPath = images[i].src.substring(
          images[i].src.indexOf('devicebits.com') + 14
        )

        const img =
          images[i].orientation === 'Landscape'
            ? `<img src="${IMG_HANDLER_URL}/fit-in/240x400/filters:rotate(90)${imgPath}" />`
            : `<img src="${images[i].src}" height="400px" width="240px"/>`
        return `${i + 1}. ${step.text} <br/>${img}<br/> `
      })
      .join('<br/>')
  }

  render() {
    const {
      createUserEvent,
      updateStep,
      language,
      playStepAnimation,
      data,
      windowDimensions,
      dropdownCount,
      currentTutorial,
      currentPhoneId,
      id,
      currentStep
    } = this.props
    const elementStyles = createStyles(STYLES.tutorial)
    const translated = messages[this.props.language]
    const flashObj = new FlashDetect()
    const panelButtons = (
      <span>
        <FeedbackContainer
          contentType="tutorials"
          contentId={data.id}
          article={currentTutorial[0].tutorial.name}
          panel
        />
        <CopyUrl />
        <ContentMailerContainer
          emailBody={this.faqTextCombined()}
          contentType="tutorials"
          contentId={data.id}
        />
      </span>
    )

    const panelTitle = (
      <div>
        <span>{currentTutorial[0].tutorial.name}</span>
        <FavouritesToggle
          contentType="tutorial"
          contentId={data.id}
          deviceId={currentPhoneId}
          contentTitle={currentTutorial[0].tutorial.name}
        />
      </div>
    )

    const isPortrait = data.portrait && windowDimensions.width >= 700
    return (
      <Row>
        <Col md={9}>
          <Panel title={panelTitle} buttons={panelButtons}>
            <Row
              id="tutorial-content"
              style={{ minHeight: dropdownCount * 30 }}
            >
              {data.type === 'INTERACTIVE' && (
                <>
                  <Col xs={isPortrait ? 5 : 12} className="interactive-device">
                    <InteractiveDevice
                      stepData={data}
                      playStepAnimation={playStepAnimation}
                      updateStep={updateStep}
                      styleBase={elementStyles.base}
                      createUserEvent={createUserEvent}
                      windowDimensions={windowDimensions}
                      automatedStep={this.automatedStep.bind(this)}
                      currentStep={currentStep}
                    />
                  </Col>
                  {windowDimensions.width <= 700 && (
                    <MobileDevice
                      show={this.state.showMobileDevice}
                      hide={this.closeMobileDevice.bind(this)}
                      stepData={data}
                      playStepAnimation={playStepAnimation}
                      updateStep={updateStep}
                      styleBase={elementStyles.base}
                      createUserEvent={createUserEvent}
                      windowDimensions={windowDimensions}
                      automatedStep={this.automatedStep.bind(this)}
                    />
                  )}
                </>
              )}
              {data.type === 'IMAGE' && <ImageDevice stepData={data} />}
              {data.type === 'MOBILE' && <></>}
              {data.type === 'FLASH' && (
                <>
                  {flashObj.installed && <FlashDevice stepData={data} />}
                  {!flashObj.installed && (
                    <div
                      style={{
                        textAlign: 'center',
                        padding: '25px',
                        color: 'rgba(255,0,0,.4)'
                      }}
                    >
                      {translated.flashError}
                    </div>
                  )}
                </>
              )}
              {data.type === 'HTML5' && (
                <Html5Device fileSrc={data.packageFile.location} />
              )}
              <Col xs={isPortrait ? 7 : 12} className="float-right">
                <StepListStyle>
                  <ScrollArea
                    speed={0.8}
                    horizontal={false}
                    style={{ maxHeight: data.portrait ? '550px' : '200px' }}
                    contentStyle={{ paddingLeft: '12px', paddingRight: '10px' }}
                    focusableTabIndex={6}
                    smoothScrolling
                    ref="scrollArea"
                  >
                    {data.steps.stepList.map((step, index) => (
                      <TutorialStep
                        key={index}
                        text={step.text}
                        stepNum={index + 1}
                        createUserEvent={createUserEvent}
                        active={step.active}
                        alreadyComplete={step.completed}
                        lastStep={step.last}
                        openMobileDevice={this.openMobileDevice.bind(this)}
                        updateStep={updateStep}
                        stepArrayLoc={step.arrayLoc}
                        language={language}
                        interactive={data.type === 'INTERACTIVE'}
                        currentTutorialId={id}
                      />
                    ))}
                  </ScrollArea>
                </StepListStyle>
              </Col>
            </Row>
          </Panel>
        </Col>
        <Col md={3}>
          <RelatedContentContainer
            contentId={id}
            contentType="tutorial"
            deviceId={currentPhoneId}
          />
        </Col>
      </Row>
    )
  }
}

export default LanguageProvider(Tutorial)
